module.exports = __webpack_public_path__ + "img/CellaVision.3be34abb.png";